import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import AnalystViewNew from 'Components/AnalystListView';
import TreeView from 'Components/TreeView';
import PrimaryButton from 'Components/Button/PrimaryButton/PrimaryButton';
import PropTypes from 'prop-types';
import './AnalystSearch.scss';
import { each } from 'Utils/lodashUtils';
import GDDetailView from 'Components/GDDetailView';
import {
  getDataForQueueMgmtLanding
} from 'Apis/queueManagerApi.js';
import { setDrawerOpenFlag } from 'Actions/drawerAction';
import HollowButton from 'Components/Button/HollowButton';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';
import { connect } from 'react-redux';

class AnalystSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSearchTerm: '',
      currentFilteredAnalysts: [],
      groupedAnalysts: [],
      selectedAnalystList: [],
      groupedSelectedAnalystList: [],
      visible: false,
      drawerOpen: false,
      selectedAnalystKeyIndex: 0,
      selectedRegionIndex: 0,
      isPrevBtnDisabled: false,
      isNextBtnDisabled: false,
      selectedAnalystForDrawer: {},
      dateFormat: this.props.analystDrawerMetaData.dateFormat,
      caseDataErr: false,
      isLoading: true,
      tableMetaData: {
        queueMetaData: this.props.analystDrawerMetaData,
        caseData: [],
        totalRecords: 0,
        totalPages: 0,
        currentPage: 0,
        recordsShown: 0,
        isNextPage: false,
        sort: this.props.analystDrawerMetaData.defaultSort,
        isTableVisible: false,
        exporting: false,
        isPagable: false
      }
    };
    this.attachBindings();
  }

  attachBindings() {
    this.searchAnalysts = this.searchAnalysts.bind(this);
    this.toggleSearchDropDown = this.toggleSearchDropDown.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.groupByRegion = this.groupByRegion.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onCountChange = this.onCountChange.bind(this);
    this.calculateCount = this.calculateCount.bind(this);
    this.onBulkAssignClick = this.onBulkAssignClick.bind(this);
    this.handleHeaderCheckbox = this.handleHeaderCheckbox.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.updateIsIndeterminate = this.updateIsIndeterminate.bind(this);
    this.updateAnalystCount = this.updateAnalystCount.bind(this);
    this.onAssignClick = this.onAssignClick.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.rowActionClick = this.rowActionClick.bind(this);
    this.gotoCaseLandingPage = this.gotoCaseLandingPage.bind(this);
  }

  componentWillMount() {

    this.props.currentGroupAnalysts.forEach(row => {
    });

    let group = this.groupByRegion(this.props.currentGroupAnalysts);
    this.updateAnalystCount(group);
    each(group, function (grp) {
      grp.isExpanded = false;
    })

    this.setState({
      currentFilteredAnalysts: group,
      groupedAnalysts: group
    });
  }

  componentWillReceiveProps(newProps) {
    if (this.props.currentGroupAnalysts !== newProps.currentGroupAnalysts) {
      this.setState({
        totalCaseCount: newProps.totalBulkCases
      });
      let group = this.groupByRegion(newProps.currentGroupAnalysts);
      this.updateAnalystCount(group);
      each(group, function (grp) {
        grp.isExpanded = false;
      })
      let selectedAnalystList = this.state.selectedAnalystList;
      newProps.currentGroupAnalysts.forEach(analyst => {
        selectedAnalystList.forEach(selectedAnalyst => {
          if (analyst.userId === selectedAnalyst.userId) {
            selectedAnalyst.assignedCasesCount = analyst.assignedCasesCount;
            if (newProps.resetCaseCount) {
              selectedAnalyst.numberOfRecordsToAssign = 0;
            }
          }
        });
      });
      if (newProps.resetCaseCount) {
        this.props.setTotalBulkCases(0);
      }
      let groupedSelectedAnalysts = this.groupByRegion(selectedAnalystList);
      group.forEach(analystGroup => {
        groupedSelectedAnalysts.forEach(selectedAnalystGroup => {
          if (analystGroup.userGroupId === selectedAnalystGroup.userGroupId) {
            analystGroup.items.forEach(analyst => {
              if (selectedAnalystGroup.items.find(o => o.userId == analyst.userId)) {
                analyst.selected = true;
              }
            })
          }
        });
      });
      this.updateIsIndeterminate(group);
      this.setState({
        selectedAnalystList: selectedAnalystList,
        groupedSelectedAnalystList: groupedSelectedAnalysts,
        currentFilteredAnalysts: group,
        groupedAnalysts: group
      });
    }

  }


  toggleSearchDropDown() {
    if (this.state.currentSearchTerm) {
      this.setState({
        visible: true,
      })
    } else {
      this.setState({ visible: !this.state.visible });
    }
  }

  groupByRegion(analystList) {
    let grp = analystList.reduce((previous, current) => {
      let nameParts = current.userGroupName;
      if (!previous[nameParts]) {
        previous[nameParts] = [Object.assign({}, current)];
      } else {
        previous[nameParts].push(Object.assign({}, current));
      }
      return previous;
    }, {});
    let group = Object.keys(grp).map(key => ({ key, items: grp[key], userGroupId: grp[key][0].userGroupId, isIndeterminate: false, selected: false }));
    this.updateIsIndeterminate(group);
    return group;
  }

  updateIsIndeterminate(analystList) {
    let that = this;
    each(analystList, function (analyst) {
      analyst.isIndeterminate = ((!analyst.items.filter(i => {
        return i.selected
      }).length == 0) && (analyst.items.filter(i => {
        return i.selected
      }).length !== analyst.items.length)),
        analyst.selected = analyst.items.filter(i => {
          return i.selected
        }).length == analyst.items.length,
        analyst.assignedCasesCount = that.calculateCount(analyst.items, 'assignedCasesCount')
    });
  }

  updateAnalystCount(analystList) {
    each(analystList, function (region) {
      region.analystsCount = region.items.length;
    });
  }

  searchAnalysts(value) {
    const lowercaseSearchTerm = value && value.toLowerCase && value.toLowerCase();
    const filteredUserstmp = this.state.groupedAnalysts.map(u => {
      u.items.map(c => {
        return Object.assign({}, c);
      })
      return Object.assign({}, u);
    })
    const filteredUsers = filteredUserstmp.filter((user) => {
      const filteredChildren = user.items.filter((child) => {
        return child.firstName.toLowerCase().includes(lowercaseSearchTerm) || child.lastName.toLowerCase().includes(lowercaseSearchTerm);
      });
      user.items = filteredChildren;
      return (filteredChildren.length > 0);
    });
    this.updateIsIndeterminate(filteredUsers);
    for (let i = 0; i < filteredUsers.length; i++) {
      filteredUsers[i].isExpanded = true;
    }
    if (value) {
      this.setState({ visible: true });
    } else {
      for (let i = 0; i < filteredUsers.length; i++) {
        filteredUsers[i].isExpanded = false;
      }
    }

    this.setState({
      currentSearchTerm: value,
      currentFilteredAnalysts: filteredUsers,
    });
  }

  handleOutsideClick() {
    this.setState({
      visible: false
    })
  }

  onCountChange(item, value) {
    let selectedAnalystListCopy = this.state.selectedAnalystList;
    selectedAnalystListCopy.forEach(analyst => {
      if (analyst.userId == item.userId) {
        analyst.numberOfRecordsToAssign = Number.isNaN(parseInt(value)) ? "0" : parseInt(value);
      }
    });
    let groupedSelectedAnalysts = this.groupByRegion(selectedAnalystListCopy);
    let totalBulkCases = this.calculateCount(selectedAnalystListCopy, 'numberOfRecordsToAssign');
    this.setState({
      groupedSelectedAnalystList: groupedSelectedAnalysts,
      selectedAnalystList: selectedAnalystListCopy,
      totalCaseCount: totalBulkCases,
    });
    this.props.setTotalBulkCases(totalBulkCases);
  }

  calculateCount(arr, type) {
    let tempArr = [];
    return arr.reduce((total, obj) => {
      if (obj[type]) {
        let unqIndex = arr.map(function (e) { return e.userId; }).indexOf(obj.userId);
        if (!tempArr.includes(unqIndex)) {
          tempArr.push(unqIndex);
          if (typeof obj[type] === 'string') {
            return total + Number(obj[type]);
          }
          return total + obj[type];
        }
      }
      return Number(total);
    }, 0);
  }

  onBulkAssignClick() {
    this.props.bulkAssignClick(this.state.selectedAnalystList);
  }

  onAssignClick = (item, type, region) => {
    if (type == "gotoAnalystDrawer") {
      document.body.style.overflow = 'hidden';
      let selectedRegionIndex = this.state.groupedSelectedAnalystList.findIndex(i => i.key == region.key);
      let selectedAnalystKeyIndex = region.items.findIndex(i => i.userId == item.userId);
      this.setState({
        drawerOpen: true,
        structureMetaData: {
          returnToText: `Return to ${this.props.returnToText}`
        },
        selectedRegionIndex: selectedRegionIndex,
        selectedAnalystKeyIndex: selectedAnalystKeyIndex,
        isPrevBtnDisabled: this.prevBtnDisabled(selectedRegionIndex, selectedAnalystKeyIndex),
        isNextBtnDisabled: this.nextBtnDisabled(selectedRegionIndex, selectedAnalystKeyIndex),
        selectedAnalystForDrawer: item
      },
        () => {
          this.getDataForQueueMgmtLanding(null, null, item.userId, 0, item.assignedCasesCount, this.state.tableMetaData.sort);
        });

      this.props.setDrawerOpenFlag(true);
    }
    else {
      this.props.onAssignClick(item, type);
    }
  }

  toggleDrawer = () => {
    document.body.style.overflow = 'visible';
    this.props.setDrawerOpenFlag(false);
    this.setState({
      drawerOpen: !this.state.drawerOpen,
    });
  }

  prevBtnDisabled = (selectedRegionIndex, selectedAnalystKeyIndex) => {
    return (selectedRegionIndex == 0 && selectedAnalystKeyIndex == 0);
  }

  nextBtnDisabled = (selectedRegionIndex, selectedAnalystKeyIndex) => {
    return (selectedRegionIndex == this.state.groupedSelectedAnalystList.length - 1 && selectedAnalystKeyIndex == this.state.groupedSelectedAnalystList[selectedRegionIndex].items.length - 1);
  }

  goToNextRecord = () => {
    if (this.state.selectedAnalystKeyIndex + 1 < this.state.groupedSelectedAnalystList[this.state.selectedRegionIndex].items.length) {
      this.setState((prevState) => ({
        selectedAnalystKeyIndex: prevState.selectedAnalystKeyIndex + 1,
        isNextBtnDisabled: this.nextBtnDisabled(this.state.selectedRegionIndex, prevState.selectedAnalystKeyIndex + 1),
        isPrevBtnDisabled: false,
        selectedAnalystForDrawer: this.state.groupedSelectedAnalystList[this.state.selectedRegionIndex].items[prevState.selectedAnalystKeyIndex + 1]
      }),
        () => {
          this.getDataForQueueMgmtLanding(null, null,
            this.state.selectedAnalystForDrawer.userId,
            0, this.state.selectedAnalystForDrawer.assignedCasesCount, this.state.tableMetaData.sort);
        }
      );
    }
    else {
      if (this.state.selectedRegionIndex + 1 < this.state.groupedSelectedAnalystList.length) {
        this.setState((prevState) => ({
          selectedRegionIndex: prevState.selectedRegionIndex + 1,
          selectedAnalystKeyIndex: 0,
          isNextBtnDisabled: this.nextBtnDisabled(prevState.selectedRegionIndex + 1, 0),
          isPrevBtnDisabled: false,
          selectedAnalystForDrawer: this.state.groupedSelectedAnalystList[prevState.selectedRegionIndex + 1].items[0]
        }),
          () => {
            this.getDataForQueueMgmtLanding(null, null,
              this.state.selectedAnalystForDrawer.userId,
              0, this.state.selectedAnalystForDrawer.assignedCasesCount, this.state.tableMetaData.sort);
          });
      }
    }

  };

  goToPreviousRecord = () => {
    if (this.state.selectedAnalystKeyIndex > 0) {
      this.setState((prevState) => ({
        selectedAnalystKeyIndex: prevState.selectedAnalystKeyIndex - 1,
        isPrevBtnDisabled: this.prevBtnDisabled(this.state.selectedRegionIndex, prevState.selectedAnalystKeyIndex - 1),
        isNextBtnDisabled: false,
        selectedAnalystForDrawer: this.state.groupedSelectedAnalystList[this.state.selectedRegionIndex].items[prevState.selectedAnalystKeyIndex - 1]
      }),
        () => {
          this.getDataForQueueMgmtLanding(null, null,
            this.state.selectedAnalystForDrawer.userId,
            0, this.state.selectedAnalystForDrawer.assignedCasesCount, this.state.tableMetaData.sort);
        }
      );
    }
    else {
      if (this.state.selectedRegionIndex > 0) {
        this.setState((prevState) => ({
          selectedRegionIndex: prevState.selectedRegionIndex - 1,
          selectedAnalystKeyIndex: this.state.groupedSelectedAnalystList[prevState.selectedRegionIndex - 1].items.length - 1,
          isPrevBtnDisabled: this.prevBtnDisabled(prevState.selectedRegionIndex - 1, this.state.groupedSelectedAnalystList[prevState.selectedRegionIndex - 1].items.length - 1),
          isNextBtnDisabled: false,
          selectedAnalystForDrawer: this.state.groupedSelectedAnalystList[prevState.selectedRegionIndex - 1].items[this.state.groupedSelectedAnalystList[prevState.selectedRegionIndex - 1].items.length - 1]
        }),
          () => {
            this.getDataForQueueMgmtLanding(null, null,
              this.state.selectedAnalystForDrawer.userId,
              0, this.state.selectedAnalystForDrawer.assignedCasesCount, this.state.tableMetaData.sort);
          });
      }
    }
  };

  getDataForQueueMgmtLanding(regionCode, queueId, userId, pageNumber, size, sort) {
    this.setState({
      caseDataErr: false,
      isLoading: true

    });
    const queueMetaDataClone = { ...this.state.tableMetaData.queueMetaData };
    return getDataForQueueMgmtLanding(regionCode, queueId, userId, pageNumber, size, sort)
      .then((apiResponse) => {
        const formattedData = apiResponse.data.content;
        this.setState((prevState) => ({
          caseDataErr: false,
          isLoading: false,
          tableMetaData: {
            queueMetaData: queueMetaDataClone,
            caseData: formattedData,
            totalRecords: apiResponse.data.totalElements,
            totalPages: apiResponse.data.totalPages,
            currentPage: apiResponse.data.number + 1,
            recordsShown: size,
            isNextPage: !apiResponse.data.last,
            sort,
            isTableVisible: true,
            exporting: false,
            isPagable: false
          }

        }));
        scroll(0, 0);
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while fetching data based on global applied filters', error);
      });
  }

  handleChange(item, e) {
    item.selected = !item.selected;
    let selectedAnalystList = this.state.selectedAnalystList;
    if (item.selected) {
      let numberOfRecordsToAssign = 0;
      selectedAnalystList.forEach(selectedUser => {
        if (selectedUser.userId === item.userId) {
          numberOfRecordsToAssign = selectedUser.numberOfRecordsToAssign;
        }
      });
      item.numberOfRecordsToAssign = numberOfRecordsToAssign;
      selectedAnalystList.push(Object.assign({}, item));
    }
    else {
      let index = selectedAnalystList.findIndex(o => o.userId == item.userId && o.userGroupName == item.userGroupName);
      if (index > -1) {
        selectedAnalystList.splice(index, 1);
      }
    }

    this.updateIsIndeterminate(this.state.currentFilteredAnalysts);
    let groupedSelectedAnalysts = this.groupByRegion(selectedAnalystList);
    this.setState({
      groupedSelectedAnalystList: groupedSelectedAnalysts,
      selectedAnalystList: selectedAnalystList,
      totalCaseCount: this.calculateCount(selectedAnalystList, 'numberOfRecordsToAssign')
    });
    this.props.setTotalBulkCases(this.state.totalCaseCount);
  }

  handleHeaderCheckbox(item) {
    item.isIndeterminate = false;
    each(item.items, function (user) {
      user.selected = item.selected
    });
    let selectedAnalystList = this.state.selectedAnalystList.length > 0 ? this.state.selectedAnalystList : [];
    if (item.selected) {
      item.items.forEach((user) => {
        let index = selectedAnalystList.findIndex(selectedUser => selectedUser.userId == user.userId && selectedUser.userGroupName == user.userGroupName);
        if (index == -1) {
          let numberOfRecordsToAssign = 0;
          selectedAnalystList.forEach(selectedUser => {
            if (selectedUser.userId === user.userId) {
              numberOfRecordsToAssign = selectedUser.numberOfRecordsToAssign;
            }
          });
          user.numberOfRecordsToAssign = numberOfRecordsToAssign;
          selectedAnalystList.push(Object.assign({}, user));
        }
      });
    }
    else {
      each(item.items, function (user) {
        let index = selectedAnalystList.findIndex(selectedUser => selectedUser.userId == user.userId && selectedUser.userGroupName == user.userGroupName);
        if (index > -1) {
          selectedAnalystList.splice(index, 1);
        }
      });
    }

    let groupedSelectedAnalysts = this.groupByRegion(selectedAnalystList);

    this.setState({
      groupedSelectedAnalystList: groupedSelectedAnalysts,
      selectedAnalystList: selectedAnalystList,
      totalCaseCount: this.calculateCount(selectedAnalystList, 'numberOfRecordsToAssign')
    });
    this.props.setTotalBulkCases(this.state.totalCaseCount);
  }

  toggleCollapse(item) {
    item.isExpanded = !item.isExpanded;
    this.setState({
      currentFilteredAnalysts: [...this.state.currentFilteredAnalysts]
    })
  }

  rowActionClick(selectedCaseIndex, key) {
    this.setState({
      selectedCaseIndex,
    });
    if (key === 'OPEN_CASE') {
      this.gotoCaseLandingPage(selectedCaseIndex);
    }
    if (key === "OPEN_CASE_IN_TAB") {
      gotoNewTabCaseLandingPage(this.state.tableMetaData.caseData[selectedCaseIndex].caseNumber);
    }
  }

  gotoCaseLandingPage(selectedCaseIndex) {
    this.props.setDrawerOpenFlag(false);
    this.setState({
      drawerOpen: false,
    });
    this.props.history.push({
      state: {
        prevPath: this.props.location.pathname,
      },
      pathname: '/caselanding/' + `${this.state.tableMetaData.caseData[selectedCaseIndex].caseNumber}`,
    });
  }

  pageHandler = () => {

  }

  handleSort = (key, sortArr) => {
    let queueId, region;
    const userId = this.state.groupedSelectedAnalystList[this.state.selectedRegionIndex].items[this.state.selectedAnalystKeyIndex].userId;
   
    this.getDataForQueueMgmtLanding(region, queueId, userId, 0, this.state.tableMetaData.recordsShown, sortArr);
  }


  get displayAnalysts() {
    return (
      <AnalystViewNew
        dataList={this.state.groupedSelectedAnalystList}
        groupedAnalysts={this.state.groupedAnalysts}
        action={this.onAssignClick}
        onCountChange={this.onCountChange}
        isChecked={this.props.isChecked}
      />
    );
  }

  render() {
    const caseText = this.state.totalCaseCount > 1 ? 'Cases' : 'Case';
    return (
      <div className="analyst-search-wrapper">
        <div className='analyst-search-heading'>
          <h2>Analysts</h2>
        </div>
        {this.props.currentGroupAnalysts.length > 0 && <div className="search-top">
          <div className="analyst-search">
            <div className="tree-autocomplete">
              <TreeView searchTerm={this.state.currentSearchTerm}
                dataList={this.state.currentFilteredAnalysts}
                handleHeaderCheckbox={this.handleHeaderCheckbox}
                onChange={this.searchAnalysts}
                onClick={this.toggleSearchDropDown}
                handleOutsideClick={this.handleOutsideClick}
                visible={this.state.visible}
                placeholder="Search For Analysts"
                extraClass="some-class"
                handleChange={this.handleChange}
                toggleCollapse={this.toggleCollapse}>
              </TreeView>
            </div>
          </div>
        </div>
        }
        <div className="search-bottom">
          {this.state.selectedAnalystList.length == 0 && this.state.visible !== true && <div className='analyst-search-prompt-text'>{this.props.promptText}</div>}
          {this.state.selectedAnalystList && this.state.selectedAnalystList.length > 0 && <div className="selected-analysts-count-header">{this.state.selectedAnalystList.length} Selected Analyst{this.state.selectedAnalystList.length > 1 ? 's' : ''}</div>}
          {this.state.selectedAnalystList && this.state.selectedAnalystList.length > 0 && this.displayAnalysts}
          {this.state.totalCaseCount > 0 && this.state.totalCaseCount <= this.props.totalCases && !this.props.isChecked && this.props.user && this.props.user.parsedPermissions.queue.bulkAssigment && <div className="bulk-assign-cases"><PrimaryButton extraClass={`button-primary__bulk-assign`} action={this.onBulkAssignClick}>
            Assign {this.state.totalCaseCount} {caseText} to Selected Analyst{this.state.selectedAnalystList.filter(analyst => analyst.numberOfRecordsToAssign > 0).length > 1 ? 's' : ''}
          </PrimaryButton></div>}
          {this.state.selectedAnalystList.length > 0 && this.state.totalCaseCount === 0 && !this.props.isChecked && this.props.user && this.props.user.parsedPermissions.queue.bulkAssigment && <div className="bulk-assign-cases"><HollowButton disabled extraClass={`button-primary__bulk-assign`} action={this.onBulkAssignClick}>
            Bulk Assignment
            </HollowButton></div>}
          {this.state.selectedAnalystList.length > 0 && this.props.isChecked && this.props.user && this.props.user.parsedPermissions.queue.bulkAssigment && <div className="bulk-assign-cases"><HollowButton disabled extraClass={`button-primary__bulk-assign`} action={this.onBulkAssignClick}>
            Bulk Assignment
            </HollowButton></div>}
          {this.state.totalCaseCount > this.props.totalCases && !this.props.isChecked && <div className="message-display">
            <b>You have entered {this.state.totalCaseCount} of {this.props.totalCases} {this.props.totalCases === 1 ? 'case' : 'cases'}.</b>
            <br />
            Please lower the number of cases.
            </div>}
        </div>
        {
          this.state.drawerOpen && <div className="drawer open">
            <GDDetailView
              type="gdTable"
              data={this.state.groupedSelectedAnalystList[this.state.selectedRegionIndex].items[this.state.selectedAnalystKeyIndex]}
              goBack={this.toggleDrawer}
              goToPreviousRecord={this.goToPreviousRecord}
              goToNextRecord={this.goToNextRecord}
              structure={[].concat(this.state.structureMetaData)}
              preferences={{}}
              recordCountSize={this.state.groupedSelectedAnalystList.length}
              selectedKeyIndex={this.state.selectedRegionIndex}
              isPrevBtnDisabled={this.state.isPrevBtnDisabled}
              isNextBtnDisabled={this.state.isNextBtnDisabled}
              tableMetaData={this.state.tableMetaData}
              dateFormat={this.state.dateFormat}
              pageHandler={this.pageHandler}
              handleSort={this.handleSort}
              caseDataErr={this.state.caseDataErr}
              isLoading={this.state.isLoading}
              rowActionClick={this.rowActionClick}
              translations={this.props.translations}
            />            
            </div>
        }
      </div>
    );
  }
}

AnalystSearch.propTypes = {
  currentGroupAnalysts: PropTypes.array.isRequired,
  totalCases: PropTypes.number.isRequired,
  bulkAssignClick: PropTypes.func,
  onAssignClick: PropTypes.func,
  returnToText: PropTypes.string,
  translations: PropTypes.object,
  analystDrawerMetaData: PropTypes.object
};

AnalystSearch.defaultProps = {

};
const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setDrawerOpenFlag: (isDrawerActive) => {
      dispatch(setDrawerOpenFlag(isDrawerActive));
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnalystSearch));
